import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 mb-3" }
const _hoisted_3 = { class: "card pt-4 mb-xl-9" }
const _hoisted_4 = { class: "card-header border-0" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "fw-bolder fs-2" }
const _hoisted_9 = { class: "fs-7 fw-normal text-muted" }
const _hoisted_10 = { class: "p-5 mt-5 mb-5 bg-primary bg-opacity-25 rounded" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col form-group" }
const _hoisted_13 = ["name", "value"]
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "col-4 mb-4" }
const _hoisted_16 = { class: "card bg-warning bg-opacity-25 h-100" }
const _hoisted_17 = { class: "card-header flex-nowrap border-0 pt-9" }
const _hoisted_18 = { class: "card-title m-0" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-line fs-3 me-3" }, null, -1)
const _hoisted_20 = {
  class: "fs-4 fw-bold text-hover-primary text-gray-600 m-0",
  href: "#"
}
const _hoisted_21 = { class: "card-body d-flex flex-column pb-8" }
const _hoisted_22 = { class: "d-flex align-items-center fw-bold" }
const _hoisted_23 = {
  key: 1,
  class: "btn bg-black text-white btn-sm btn-active-light-primary disabled",
  target: "_blank"
}
const _hoisted_24 = { class: "col-4 mb-4" }
const _hoisted_25 = { class: "card bg-warning bg-opacity-25 h-100" }
const _hoisted_26 = { class: "card-header flex-nowrap border-0 pt-9" }
const _hoisted_27 = { class: "card-title m-0" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-line fs-3 me-3" }, null, -1)
const _hoisted_29 = {
  class: "fs-4 fw-bold text-hover-primary text-gray-600 m-0",
  href: "#"
}
const _hoisted_30 = { class: "card-body d-flex flex-column pb-8" }
const _hoisted_31 = {
  key: 0,
  class: "d-flex align-items-center fw-bold"
}
const _hoisted_32 = {
  key: 1,
  class: "row-auto flex-center"
}
const _hoisted_33 = { class: "progress" }
const _hoisted_34 = ["aria-valuenow"]
const _hoisted_35 = { class: "row-auto flex-center mt-4" }
const _hoisted_36 = {
  key: 0,
  class: "col-4 mb-4"
}
const _hoisted_37 = { class: "card bg-warning bg-opacity-25 h-100" }
const _hoisted_38 = { class: "card-header flex-nowrap border-0 pt-9" }
const _hoisted_39 = { class: "card-title m-0" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-line fs-3 me-3" }, null, -1)
const _hoisted_41 = {
  class: "fs-4 fw-bold text-hover-primary text-gray-600 m-0",
  href: "#"
}
const _hoisted_42 = { class: "card-body d-flex flex-column pb-8" }
const _hoisted_43 = { class: "d-flex align-items-center fw-bold" }
const _hoisted_44 = ["href"]
const _hoisted_45 = { class: "col-12 mb-4" }
const _hoisted_46 = { class: "card h-100" }
const _hoisted_47 = { class: "card-header flex-nowrap border-0 pt-9" }
const _hoisted_48 = { class: "card-title m-0" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-line fs-3 me-3" }, null, -1)
const _hoisted_50 = {
  class: "fs-4 fw-bold text-hover-primary text-gray-600 m-0",
  href: "#"
}
const _hoisted_51 = { class: "card-body d-flex flex-column pb-8" }
const _hoisted_52 = { class: "custom-tree-node" }
const _hoisted_53 = ["href"]
const _hoisted_54 = ["onClick", "title"]
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-file-pdf me-3 fs-5" }, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-file-excel me-3 fs-5" }, null, -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { key: 2 }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-file-csv me-3 fs-5" }, null, -1)
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = { key: 3 }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-file-alt me-3 fs-5" }, null, -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { key: 4 }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-solid fa-file-powerpoint me-3 fs-5" }, null, -1)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { key: 5 }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sharp fa-solid fa-file-word me-3 fs-5" }, null, -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { key: 6 }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sharp fa-solid fa-file-word me-3 fs-5" }, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { key: 7 }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sharp fa-solid fa-file-image me-3 fs-5" }, null, -1)
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { key: 8 }
const _hoisted_80 = { key: 1 }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex row-auto flex-center w-100 h-200px" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "spinner-border text-primary",
    role: "status"
  })
], -1)
const _hoisted_82 = [
  _hoisted_81
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tree = _resolveComponent("el-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("pages.results.title")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("pages.results.desc")), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCampaignId) = $event)),
                  class: "form-control form-control-solid"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (campaign) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: campaign.id,
                      name: campaign.label,
                      value: campaign.id
                    }, _toDisplayString(campaign.label), 9, _hoisted_13))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedCampaignId]
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary btn-light",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reloadData()))
                }, _toDisplayString(_ctx.$t("general.search")), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("a", _hoisted_20, _toDisplayString(_ctx.$t("pages.results.groupreport")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (this.groupReportLink)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "btn btn-warning btn-sm btn-light btn-active-light-primary",
                        target: "_blank",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (this.downloadGroupReport()))
                      }, _toDisplayString(_ctx.$t("pages.results.accessResults")), 1))
                    : (_openBlock(), _createElementBlock("a", _hoisted_23, _toDisplayString(_ctx.$t("general.noavailable")), 1))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("a", _hoisted_29, _toDisplayString(_ctx.$t("pages.results.downloadbyperimeter")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                (!_ctx.loadingZip)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("a", {
                        class: "btn btn-warning btn-sm btn-light btn-active-light-primary",
                        target: "_blank",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (this.getAllReports()))
                      }, _toDisplayString(_ctx.$t("pages.results.accessResults")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("span", {
                          class: "progress-bar progress-bar-striped progress-bar-animated",
                          role: "progressbar",
                          style: _normalizeStyle({ width: _ctx.progressBarWidth + '%' }),
                          "aria-valuenow": _ctx.progressBarWidth,
                          "aria-valuemin": "0",
                          "aria-valuemax": "100"
                        }, null, 12, _hoisted_34)
                      ]),
                      _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("pages.results.loadingZip")), 1)
                    ]))
              ])
            ])
          ]),
          (this.$store.getters.currentUser.user.userprofile.softconcept)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("a", _hoisted_41, _toDisplayString(_ctx.$t("pages.results.customizewebreporting")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("a", {
                        href: this.$store.getters.currentUser.user.userprofile.softconcept,
                        class: "btn btn-warning btn-sm btn-light btn-active-light-primary",
                        target: "_blank"
                      }, _toDisplayString(_ctx.$t("pages.results.accessResults")), 9, _hoisted_44)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("a", _hoisted_50, _toDisplayString(_ctx.$t("pages.results.entityreport")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_el_tree, {
                  data: _ctx.entities,
                  "default-expanded-keys": _ctx.defaultExpandedKeys,
                  "node-key": "id",
                  ref: "tree",
                  "highlight-current": "",
                  props: _ctx.defaultProps,
                  onNodeExpand: _ctx.handleNodeClick,
                  onNodeCollapse: _ctx.handleNodeClick
                }, {
                  default: _withCtx(({ node, data }) => [
                    _createElementVNode("span", _hoisted_52, [
                      _createElementVNode("span", null, _toDisplayString(node.label), 1),
                      _createElementVNode("span", null, [
                        (data.externalcompanyresults.length > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: data.externalcompanyresults[0].link,
                              target: "_blank",
                              class: "primary-color"
                            }, " Accéder aux Résultats ", 8, _hoisted_53))
                          : _createCommentVNode("", true),
                        (data.resultfile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data.resultfile, (fileres) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: fileres.id,
                                onClick: ($event: any) => (_ctx.downloadReport(fileres)),
                                target: "_blank",
                                class: "primary-color",
                                style: {"z-index":"100"},
                                title: fileres.name
                              }, [
                                (fileres.extension === 'pdf')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_55, _hoisted_57))
                                  : (fileres.extension === 'xlsx')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, _hoisted_60))
                                    : (fileres.extension === 'csv')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_61, _hoisted_63))
                                      : (fileres.extension === 'txt')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, _hoisted_66))
                                        : (fileres.extension === 'pptx')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_67, _hoisted_69))
                                          : (fileres.extension === 'docx')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_70, _hoisted_72))
                                            : (fileres.extension === 'doc')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_73, _hoisted_75))
                                              : (fileres.extension === 'jpeg' || fileres.extension === 'jpg')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_76, _hoisted_78))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_79, "Télécharger " + _toDisplayString(fileres.extension), 1))
                              ], 8, _hoisted_54))
                            }), 128))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(" Résultats non disponible ")
                            ], 64))
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["data", "default-expanded-keys", "props", "onNodeExpand", "onNodeCollapse"])
              ])
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_80, _hoisted_82))
  ]))
}